import { mapGetters, mapMutations } from 'vuex'
import { getTeamLabelByNumber } from '../components/pages/TraderMode/utils/utils'

export default {
  methods: {
    setStatisticByType (handler, period, team, actionType, statisticType) {
      const handlerType = typeof handler

      if (handlerType === 'string') {
        this.updateStatistic({
          statisticType,
          property: handler,
          period,
          team,
          type: actionType
        })

        return
      }

      handler.forEach(handler => {
        this.updateStatistic({
          statisticType,
          property: handler,
          period,
          team,
          type: actionType
        })
      })

      // TODO  дописать обработку функций в мэпе ивентов (если понадобится)
    },
    setStatistic (event, relatedEvent) {
      const { getMatchPeriods } = this
      let eventCode = event['EventCode']
      let eventGamePeriod = event['GamePeriod']

      if (eventGamePeriod === undefined) return

      let eventTeamNumber = event['TeamNumber']

      const { overriddenType } = getMatchPeriods[eventGamePeriod] || {}

      if (overriddenType === 'shootout') return

      if (
        !eventGamePeriod &&
        eventCode !== 'HEARTBEAT'
      ) return

      const { getStatisticScheme } = this

      if (!getStatisticScheme) return

      const {
        sport: {
          scheme: {
            modules: {
              statistic: { statisticFunction }
            }
          }
        }
      } = this

      const {
        defaultStatistic,
        customStatistic
      } = getStatisticScheme

      const { statisticEvents } = defaultStatistic

      if (statisticFunction) {
        statisticFunction.bind(this)(event, relatedEvent)
      }

      const isCancelEvent = eventCode === 'CANCEL'
      const actionType = isCancelEvent ? 'decrement' : 'increment'

      if (isCancelEvent && relatedEvent) {
        eventCode = relatedEvent['EventCode']
        eventGamePeriod = relatedEvent['GamePeriod']
        eventTeamNumber = relatedEvent['TeamNumber']
      }

      if (isCancelEvent && !relatedEvent) {
        return
      }

      const team = getTeamLabelByNumber(eventTeamNumber)
      const handledEvent = isCancelEvent
        ? relatedEvent
        : event

      const statisticEventHandler = statisticEvents[handledEvent.EventCode]

      if (statisticEventHandler) {
        this.setStatisticByType(
          statisticEventHandler,
          eventGamePeriod,
          team,
          actionType,
          'defaultStatistic'
        )
      }

      if (!customStatistic) return

      const customStatisticEventHandler =
        customStatistic.statisticEvents[handledEvent.EventCode]

      if (!customStatisticEventHandler) return

      this.setStatisticByType(
        customStatisticEventHandler,
        eventGamePeriod,
        team,
        actionType,
        'customStatistic'
      )
    }
  }
}
